// extracted by mini-css-extract-plugin
export var active = "_8i-a";
export var activeIndicator = "_8i-9";
export var disabled = "_8i-b";
export var fullWidth = "_8i-2";
export var lg = "_8i-7";
export var md = "_8i-6";
export var redoButtonTabGroup = "_8i-0";
export var sm = "_8i-5";
export var tabButton = "_8i-4";
export var tabButtonsContainer = "_8i-1";
export var themeDestructive = "_8i-d";
export var themeNormal = "_8i-c";
export var themeSuccess = "_8i-e";
export var xl = "_8i-8";
export var xs = "_8i-3";